import { CSSProperties, MouseEvent, type ReactNode } from 'react';

import styles from './IconButton.module.scss';
import { ButtonShared } from './ButtonShared';
import { ButtonColor } from './ButtonColor';
import { ButtonVariant } from './ButtonVariant';

interface Props {
  'aria-label': string;
  children: ReactNode;
  href?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  type?: 'button' | 'submit' | 'reset' | undefined;
  color?: ButtonColor;
  variant?: ButtonVariant;
  disabled?: boolean;
  onClick?: (event: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => void;
  onBlur?: () => void;
  onHold?: () => void;
  style?: CSSProperties;
}

export function IconButton(props: Props) {
  const { size = 'medium' } = props;

  const className = [styles['icon-button'], styles[`icon-button-size-${size}`]]
    .filter(Boolean)
    .join(' ');

  return (
    <ButtonShared className={className} {...props}>
      {props.children}
    </ButtonShared>
  );
}
